module.exports = __webpack_public_path__ + "img/partner-hover6.7c8b19d5.png";